import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

//interfaces
import { ICourseGroup } from 'store/StateInterfaces';

//Components
import Group from '../Components/Group';

//Assets 
import { Row, Col, ListGroup, Container, Button, Accordion } from 'react-bootstrap';

// actions
import { loadCourseGroupsRequest } from '../Actions/Actions';


interface IProps {
    courseid: any;
    groupid: any;
    loaded: boolean;
    groups: Array<ICourseGroup>;
    actions: any;
};

class CoursePlaylist extends React.Component<IProps, {}> {

    componentDidMount() {
        if (!this.props.loaded) {
            this.props.actions.loadCourseGroupsRequest(this.props.courseid);
        }
    }

    public render() {
        let groups = null;
        if (!this.props.loaded) {
            groups = <p>Loading...</p>;
        }
        else {
            if (this.props.groups.length === 0) {
                groups = (
                    <div className="alert alert-danger alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                        No content found in this course
                    </div>);
            }
            else {
                /* doubt */
                if (this.props.groupid == "" || this.props.groupid == undefined) {
                    groups = this.props.groups.map(
                        (group, i) => {
                            return <Group
                                key={group.id} group={group} index={i} />;
                        }
                    );
                } else {
                    // var check = this.props.groupid;
                    groups = this.props.groups.map(
                        (group, i) => {
                            if (this.props.groupid == group.id) {
                                return <Group
                                    key={group.id} group={group} index={i} />;
                            }
                        });
                    groups = groups.filter((n) => {
                        return n != undefined;
                    });
                    groups = groups[0];
                }
            }


        }


        return (
            <Container style={{ border: "1px solid rgb(190,190,190)", padding: '2%', marginLeft: '0%' }}>
                <Row className="d-flex align-items-center">
                    <Col md={{ span: 4, offset: 0 }}>
                        <h4 style={{ color: 'grey' }}>
                            Multimedia Book
                        </h4>
                    </Col>
                </Row>
                <hr
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        height: '1px',
                        border: 'none',
                        backgroundColor: 'grey'
                    }}
                />

                <br />
                <Row>
                    <Col md={{ span: 12 }}>
                        <Accordion defaultActiveKey="0" id="groupListContainer">
                            {groups}
                        </Accordion>

                    </Col>
                </Row>

            </Container>

        );
    }
};


interface IReduxState {
    studentCourseGroupsMap: Map<number, Array<ICourseGroup>>;
}

const mapStateToProps = (state: IReduxState, { courseid, groupid }) => {
    if (state.studentCourseGroupsMap.has(courseid)) {
        return {
            loaded: true,
            groups: state.studentCourseGroupsMap.get(courseid),
            courseid,
            groupid
        }
    }
    else {
        return {
            loaded: false,
            groups: [],
            courseid,
            groupid
        }
    }
}


const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ loadCourseGroupsRequest }, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(CoursePlaylist);